import Tabs, { TabList, TabPanel } from '@atlaskit/tabs';
import { css } from '@compiled/react';
import { useNavigate } from 'react-router-dom';
import { ReactElement } from 'react';

import { MyLearningOnDemandContent } from 'src/pages/MyLearningPage/children/MyLearningOnDemandContent';
import { MyLearningPageContentSections } from 'src/pages/MyLearningPage/constants';
import { sendUIEvent } from 'src/utils/analytics';
import { useAtlassianUser } from 'src/hooks/useAtlassianUser';

import { CustomTab } from './CustomTab';
import { LiveTrainingTab } from './LiveTrainingTab';
import { EMPTY_STATE_TYPES, LearningEmptyState } from './LearningEmptyStateV2';

export const MY_LEARNING_TAB_PATHS = ['on-demand', 'live-training', 'certifications'];

interface MyLearningTabsProps {
  activeTabIndex: number;
}

export const MyLearningTabs = ({ activeTabIndex }: MyLearningTabsProps): ReactElement => {
  const { user } = useAtlassianUser();
  const navigate = useNavigate();

  const handleTabChange = (index: number): void => {
    const targetPath = MY_LEARNING_TAB_PATHS[index];

    navigate(`/my-learning/${targetPath}`);

    user &&
      sendUIEvent(
        'myLearningScreen',
        'tab',
        'clicked',
        'myLearningTab',
        {
          learningTab: targetPath,
        },
        user.account_id,
      );
  };

  return (
    <div css={tabsListContainerStyles} data-testid="my-learning-tabs">
      <Tabs onChange={handleTabChange} id="default" defaultSelected={activeTabIndex} selected={activeTabIndex}>
        <TabList>
          <CustomTab label="On-demand" />
          <CustomTab label="Live training" />
          <CustomTab label="Certifications" />
        </TabList>
        {MY_LEARNING_TAB_PATHS.map((path) => {
          return (
            <TabPanel key={path}>
              <div css={emptyTabContainerStyles} key={path}>
                {path === MyLearningPageContentSections.ON_DEMAND && <MyLearningOnDemandContent />}
                {path === MyLearningPageContentSections.LIVE_TRAININGS && <LiveTrainingTab />}
                {path === MyLearningPageContentSections.CERTIFICATIONS && (
                  <LearningEmptyState emptyStateType={EMPTY_STATE_TYPES.CERTIFICATIONS_EMPTY} />
                )}
              </div>
            </TabPanel>
          );
        })}
      </Tabs>
    </div>
  );
};

const tabsListContainerStyles = css({
  marginTop: '28px',
});

const emptyTabContainerStyles = css({
  width: '100%',
  margin: '0 auto',
});
